module.exports = __webpack_public_path__ + "static/media/Telegram_logo.73f9a0ed.svg";